const AuthModule = () => import('./AuthModule.vue')
const LoginForm = () => import('./views/LoginForm.vue')
const Access = () => import('./views/Access.vue')

export const authModuleRoute = {
  name: 'auth',
  path: '/auth',
  component: AuthModule,
  children: [
    {
      path: 'login',
      name: 'auth.login',
      component: LoginForm,
    },
    {
      path: 'access',
      name: 'auth.access',
      component: Access,
    },
    {
      path: 'verification',
      name: 'auth.verification',
      component: () => import('./views/OneTimePassword.vue'),
    },
  ],
}
